module.exports = __webpack_public_path__ + "img/prognos.a5ae877b.svg";